/* eslint-disable @typescript-eslint/no-useless-constructor */
import React, { Component } from 'react';
import { WithStyles } from 'decorators/withStyles';
import { ERROR_IMAGE } from 'settings';

interface IProps {
  productId: string | number;
  title: string;
  image: string;
  classes?: any;
}
@WithStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 32
  },
  image: {
    width: 40,
    height: 40,
    border: '1px solid #efefef',
    objectFit: 'cover',
    borderRadius: 4,
    marginRight: 10
  },
  span: {
    color: '#37474F',
    textAlign: 'left',
    fontFamily: 'Lato',
    wordBreak: 'break-word'
  }
}))
export default class DescriptionProduct extends Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);
  }

  render(): JSX.Element {
    const { productId, title, image, classes } = this.props;

    if (!productId || !title) {
      return null;
    }

    return (
      <div className={classes.container}>
        <img
          className={classes.image}
          alt="Imagem do produto"
          src={image}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = ERROR_IMAGE;
          }}
        />
        <span className={classes.span}>{`${productId} - ${title}`}</span>
      </div>
    );
  }
}
